"use client";

import useLogout from "@workspace/casino_pages/legacyLayer/client/components/LogoutButton/hooks/useLogout";
import { getTabId } from "@workspace/casino_pages/legacyLayer/client/utils/authenticate/notifyAuth";
import { onProfileLogout } from "@workspace/layout-ui/src/components/Header/Profile/profileLogoutEvent";
import { useEffect } from "react";

type Props = {
  siteConfig: SiteConfig;
  cognitoConfig?: CognitoConfigFragment;
};

const ProfileLogoutListener: FC<Props> = ({ siteConfig, cognitoConfig }) => {
  const { logout } = useLogout(siteConfig, cognitoConfig);
  useEffect(() => onProfileLogout(logout), [logout]);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!params.has("logoutConfirm")) return;

    setTimeout(() => {
      params.delete("logoutConfirm");
      window.history.replaceState(
        {},
        "",
        location.pathname + (params.toString() ? `?${params}` : ""),
      );
    }, 500);

    logout();
  }, [logout]);

  useEffect(() => {
    if (siteConfig.isBridgeSite) return;
    if (typeof BroadcastChannel === "undefined") return;
    const ch = new BroadcastChannel("casino_auth");
    ch.onmessage = (e) => {
      if (e.data?.type !== "logout") return;
      if (e.data?.from === getTabId()) return;
      if (location.pathname.includes("/login")) return;
      location.assign("/login");
    };
    return () => ch.close();
  }, [siteConfig.isBridgeSite]);

  return null;
};

export default ProfileLogoutListener;
